var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmptyVehiclePerformance = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaeaf3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#babed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9399b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vehicle_performance",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6963",
    "data-name": "Ellipse 6963",
    cx: 75,
    cy: 75,
    r: 75,
    transform: "translate(5 5)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34823",
    "data-name": "Group 34823",
    transform: "translate(42.119 30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34820",
    "data-name": "Group 34820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63023",
    "data-name": "Path 63023",
    d: "M6.11,0H69.652a6.11,6.11,0,0,1,6.11,6.11V94.092a6.11,6.11,0,0,1-6.11,6.11H6.11A6.11,6.11,0,0,1,0,94.092V6.11A6.11,6.11,0,0,1,6.11,0Z",
    transform: "translate(75.762 100.202) rotate(180)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34821",
    "data-name": "Group 34821",
    transform: "translate(4.686 4.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63024",
    "data-name": "Path 63024",
    d: "M112.993,125.515H47.007a.2.2,0,0,1-.2-.2V34.888a.2.2,0,0,1,.2-.2h65.986a.2.2,0,0,1,.2.2v90.425A.2.2,0,0,1,112.993,125.515Zm-65.784-.4h65.582V35.09H47.209Z",
    transform: "translate(-46.805 -34.686)",
    fill: "#eaeaf3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34822",
    "data-name": "Group 34822",
    transform: "translate(9.621 10.998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18059",
    "data-name": "Rectangle 18059",
    width: 18.329,
    height: 2.444,
    transform: "translate(36.659)",
    fill: "#969bb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18060",
    "data-name": "Rectangle 18060",
    width: 18.329,
    height: 2.444,
    transform: "translate(36.659 4.888)",
    fill: "#b6bacc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18061",
    "data-name": "Rectangle 18061",
    width: 18.329,
    height: 2.444,
    transform: "translate(36.659 9.775)",
    fill: "#d1d5e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18062",
    "data-name": "Rectangle 18062",
    width: 54.988,
    height: 2.444,
    transform: "translate(0 18.329)",
    fill: "#eaeaf3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18063",
    "data-name": "Rectangle 18063",
    width: 54.988,
    height: 2.444,
    transform: "translate(0 25.661)",
    fill: "#eaeaf3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34824",
    "data-name": "Group 34824",
    transform: "translate(59.111 75.61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18064",
    "data-name": "Rectangle 18064",
    width: 8.048,
    height: 22.654,
    transform: "translate(0 11.086)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18065",
    "data-name": "Rectangle 18065",
    width: 8.048,
    height: 19.665,
    transform: "translate(11.243 14.075)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18066",
    "data-name": "Rectangle 18066",
    width: 8.048,
    height: 30.045,
    transform: "translate(22.487 3.696)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63025",
    "data-name": "Path 63025",
    d: "M100.889,109.35H92.841V75.7a.087.087,0,0,1,.088-.088H100.8a.087.087,0,0,1,.088.088Z",
    transform: "translate(-59.111 -75.61)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18067",
    "data-name": "Rectangle 18067",
    width: 54.988,
    height: 2.444,
    transform: "translate(52.506 109.35)",
    fill: "#b9bdd0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18068",
    "data-name": "Rectangle 18068",
    width: 54.988,
    height: 2.444,
    transform: "translate(52.506 116.682)",
    fill: "#b9bdd0"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyVehiclePerformance, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-vehicle-performance.d933f288.svg";
export { ForwardRef as ReactComponent };